import React, { memo } from 'react'
import { Box, Menu } from '@mui/material'

import { getTopHeight } from '../../../util/style.helpers'

const HeaderMenu = ({ id, open, onClose, heading, body, width = 385 }) => {
  return (
    <Menu
      id={id}
      anchorEl={open}
      keepMounted
      open={Boolean(open)}
      onClose={onClose}
      sx={{
        '& .MuiMenu-paper': {
          width: `${width}px`,
          top: `${getTopHeight(70)}px !important`
        },
        '& .MuiList-padding': {
          p: '30px'
        }
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      {heading && (
        <Box
          sx={{
            mb: 1
          }}
        >
          {heading}
        </Box>
      )}
      {body}
    </Menu>
  )
}

export default memo(HeaderMenu)
